
import React from 'react';
import { LogOut } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { User } from '@supabase/supabase-js';

interface SidebarUserProfileProps {
  user: User | null;
  isSidebarOpen: boolean;
  onLogout: () => void;
}

const SidebarUserProfile: React.FC<SidebarUserProfileProps> = ({ 
  user, 
  isSidebarOpen, 
  onLogout 
}) => {
  // Get user's name from email
  const userEmail = user?.email || '';
  const userName = user?.user_metadata?.full_name || 
                 user?.user_metadata?.name || 
                 userEmail.split('@')[0] || 
                 'User';
  
  // Get initials for avatar
  const userInitials = userName
    .split(' ')
    .map(name => name[0])
    .join('')
    .toUpperCase()
    .substring(0, 2);

  return (
    <div className="p-4 border-t sticky bottom-0 bg-card mt-auto">
      <div className={cn(
        "flex items-center justify-between",
        !isSidebarOpen && "justify-center"
      )}>
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-primary-foreground">
            <span className="text-sm font-medium">{userInitials}</span>
          </div>
          <div className={cn(
            "transition-opacity duration-200",
            !isSidebarOpen && "opacity-0 hidden md:hidden"
          )}>
            <div className="font-medium">{userName}</div>
            <div className="text-xs text-muted-foreground">{userEmail}</div>
          </div>
        </div>
        <Button 
          variant="ghost" 
          size="icon"
          onClick={onLogout}
          className={cn(
            !isSidebarOpen && "hidden"
          )}
        >
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default SidebarUserProfile;
